export enum SearchType {
  Regular,
  AiAgent,
  AiDeal,
}
